/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Why a season row's source edit was refused. Sent as errorCode next to error, with surveyIds naming the refused sources and, for the two held-source codes, conflictingRows describing the season rows that hold them.
 */
export enum SurveySeasonSurveyReplacementErrorCode {
    SEASON_RUN_IN_PROGRESS = 'seasonRunInProgress',
    SOURCE_USED_BY_ANOTHER_ROW = 'sourceUsedByAnotherRow',
    SOURCE_HELD_BY_PUBLISHED_ROW = 'sourceHeldByPublishedRow',
    SOURCE_NOT_IN_SEASON_PLAN = 'sourceNotInSeasonPlan',
    SOURCE_PUBLICNESS_MISMATCH = 'sourcePublicnessMismatch',
}
